module.exports = __webpack_public_path__ + "static/media/ipad.84fc76ff.png";